<style lang="scss">
.slide-27 {
  background-image: url(../../../assets/module1/slide27/background-01.jpg);
  background-size: cover;
  background-position: center;
  .close {
    position: absolute;
    width: 100px;
    right: 10px;
    bottom: 10px;
  }
  h1 {
    font-size: 195px;
    padding-right: 52px;
    color: #e2c858;
    transform-origin: 100% 0%;
    transform: rotate(-4deg);
  }
  .title-wrap {
    right: 0;
    top: 4px;
    position: absolute;
    display: inline-block;
    left: 0;
    text-align: center;
  }
  p {
    font-size: 32px;
    color: #ffffff;
    margin-bottom: 35px;
    line-height: 1.4;
    a {
      color: #ffffff;
      text-decoration: none;
    }
    &.small {
      padding-right: 50px;
    }
  }
  .content {
    max-width: 525px;
    position: absolute;
    left: 150px;
    top: 485px;
  }
  .right-text {
    margin-top: 50px;
    text-align: right;
  }
  h2 {
    position: absolute;
    top: 330px;
    left: 150px;
    color: #68378d;
    font-size: 56px;
    line-height: 1.1em;
    transform: rotate(-4deg);
    span {
      display: block;
      &:last-of-type {
        transform: translate(71px, -5px);
      }
    }
    &.heading-right {
      left: auto;
      right: 140px;
      transform: none;
      transform-origin: 50%;
      color: #ffffff;
      span {
        &:nth-child(1) {
          margin-bottom: 20px;
        }
        &:nth-child(2) {
          color: #68378d;
        }
        &:nth-child(3) {
          transform: translateX(50px);
        }
        &:nth-child(4) {
          transform: translateX(25px);
        }
        &:nth-child(5) {
          transform: translateX(50px);
        }
        &:nth-child(6) {
          transform: translateX(150px);
        }
      }
    }
  }
}
</style>

<template>
  <div class="slide-27">
    <transition name="scale" appear>
      <div class="title-wrap" v-show="slideIndex == 26">
        <h1>{{ $t("module1.slide27.heading") }}</h1>
      </div>
    </transition>
    <transition name="fadeLeft" appear>
      <div class="delay-4" v-show="slideIndex == 26">
        <h2 v-html="$t('module1.slide27.heading2')"></h2>
      </div>
    </transition>
    <transition name="fadeRight" appear>
      <div class="content delay-4" v-show="slideIndex == 26">
        <div v-show="slideIndex == 26">
          <p>{{ $t("module1.slide27.paragraph") }}</p>
          <p class="small">{{ $t("module1.slide27.paragraph2") }}</p>
          <p>
            <a href="http://www.fastheroes.com/" target="_blank"
              >www.fastheroes.com</a
            >
          </p>
        </div>
      </div>
    </transition>
    <transition name="fadeRight" appear>
      <h2
        class="heading-right delay-6"
        v-show="slideIndex == 26"
        v-html="$t('module1.slide27.heading3')"
      ></h2>
    </transition>
    <transition name="scale" appear>
      <img
        v-show="slideIndex == 26"
        src="@/assets/module1/slide27/timmy-09.png"
        class="chars delay-2"
      />
    </transition>
    <img
      @click.prevent="reload()"
      class="close"
      src="@/assets/module1/slide27/button_close.png"
    />
  </div>
</template>

<script>
export default {
  props: ["slideIndex"],
  methods: {
    reload() {
      window.location = "/e-books/";
    }
  }
};
</script>
